import React from "react";
import { Outlet } from "react-router";
import { ReviewDetail } from "./ReviewDetails";
import { useReviewTabContext } from "./ReviewTabContext";

export const ReviewDetailsTab: React.FC = () => {
  const ctx = useReviewTabContext();
  return (
    <>
      <ReviewDetail
        canApprove={ctx.canApprove}
        data={ctx.data}
        reportData={ctx.reportData}
        isComplete={ctx.isComplete}
        isLoading={ctx.isLoading}
        hasOutdatedDesignElements={ctx.hasOutdatedDesignElements}
      />
      <Outlet />
    </>
  );
};
